import { Hidden, HStack, Pressable, Text, VStack } from 'native-base';
import Button from 'ui/components/Button';
import Illustration, { ILLUSTRATIONS_NAME } from 'ui/components/Illustration';
import { colors } from 'ui/theme/colors';

import { PAGES } from '~/constants/pages.constants';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useRouter } from '~/hooks/useRouter';

export const ContentBanner = () => {
  const { selectedEcosystem } = useAppSelector(({ ecosystem }) => ecosystem);

  const { goToRoute } = useRouter();

  const goToDownloadContent = () => {
    if (!selectedEcosystem?._id) return;

    goToRoute(
      PAGES.EcosystemDownloadFiles.replace(
        ':ecosystemId',
        selectedEcosystem._id || '',
      ),
    );
  };

  return (
    <Pressable onPress={goToDownloadContent}>
      <VStack p={6} bgColor={colors.purple[500]} borderRadius={12}>
        <HStack justifyContent="space-between">
          <VStack>
            <Text
              color={colors.singletons.white}
              fontSize={{ base: 'md', md: '2xl' }}
              fontWeight={500}
            >
              Expand Your Skills With Our Learning Content
            </Text>
            <Text
              mt={1}
              color={colors.singletons.white}
              fontSize={{ base: 'sm', md: 'lg' }}
            >
              Discover a range of short courses designed to help you grow.
              Download our learning content and build valuable skills and
              insights!
            </Text>
            <Button
              onPress={goToDownloadContent}
              mt={8}
              h="44px"
              bgColor="singletons.white"
              maxWidth={{ base: 'full', md: '192px' }}
              _text={{
                fontWeight: 500,
                fontSize: { base: 'md' },
                color: 'singletons.black',
              }}
            >
              Download Contents
            </Button>
          </VStack>

          <Hidden till="md">
            <Illustration
              name={ILLUSTRATIONS_NAME.DOWNLOAD}
              height="160px"
              width="179px"
            />
          </Hidden>
        </HStack>
      </VStack>
    </Pressable>
  );
};
